<p-multiSelect [ngModel]="assetCategories"  name="assetCategories" [disabled]="mode !== DetailMode.EDITION"
               (ngModelChange)="assetCategoriesChange.emit($event)" (onClear)="assetCategoriesChange.emit()"
               [options]="assetCategoryOptions" optionLabel="value" optionValue="value"
               [filter]="true" [filterBy]="filterLabelField" appendTo="body"
               [showClear]="true" [showToggleAll]="false" i18n-placeholder="@@common-none" placeholder="(none)" display="chip"
               [required]="required" class="acted-highlight-req metadata-field" [tabindex]="tabindex">
  <ng-template pTemplate="item"  let-item>
    {{ item[filterLabelField] }}
  </ng-template>
</p-multiSelect>
